import { createContext } from 'react';

import { ICommentsMainContext } from '@widgets/Comments/model/types';

export const CommentsMainContext = createContext<ICommentsMainContext | null>(null);
